module.exports = __webpack_public_path__ + "static/img/hand-and-phone-bank-e-auctions.28114a74.png";